import { render, staticRenderFns } from "./CreateNewMarketTypeModal.vue?vue&type=template&id=1e9ec586&"
import script from "./CreateNewMarketTypeModal.vue?vue&type=script&lang=js&"
export * from "./CreateNewMarketTypeModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports